import React, { Component } from "react";
import Form from "./Form";
import { compose } from "redux";
import { withUrlResource, withUrlResourceTimezone } from "common/utils";
import resourceFactory from "common/admin/resourceFactory";
import Resource from "common/components/Resource";

class CreateQuickLinks extends Component {
  constructor(props) {
    super(props);
    this.currentRecordRef = React.createRef();
  }
  componentDidMount() {
    this.getQuickLinks();
  }
  getQuickLinks = async () => {
    const { id } = this.props.urlResource;
    const actions = resourceFactory(`buildings/${id}/quick_links`);
    const data = await actions.getAll();
    this.currentRecordRef.current = data.links && data.links.length;
    try {
    } catch (error) {
      this.currentRecordRef.current = false;
    }
  };
  handleSubmit = async (values, form) => {
    const actions = resourceFactory(
      `buildings/${this.props.urlResource.id}/quick_links`
    );
    const { name, icon, type, action, priority } = values;
    const { setSubmitting, setErrors, setStatus, resetForm } = form;
    const payload = { name, icon, type, action, priority };
    try {
      if (this.currentIdRef.current) {
        await actions.update(this.currentIdRef.current, {
          links: { ...payload },
        });
      } else {
        await actions.create({
          links: {
            ...payload,
          },
        });
      }

      resetForm();
      setStatus({ success: true });
    } catch (e) {
      setErrors({ http: e.message });
    }
    setSubmitting(false);
  };
  render() {
    const { urlResource } = this.props;
    return (
      <Resource
        name="floors"
        queryParams={{ building_id: urlResource.id }}
        render={() => (
          <Form
            handleSubmit={this.handleSubmit}
            initialValues={{
              name: "",
              icon: "",
              type: "routelink",
              action: "",
              priority: 1,
            }}
          />
        )}
      />
    );
  }
}

const enhanced = compose(withUrlResource, withUrlResourceTimezone);

export default enhanced(CreateQuickLinks);
